import Vue from "vue";
import Vuetify from "vuetify/lib/framework";

Vue.use(Vuetify);

export default new Vuetify({
  customVariables: ["~/sass/variables.scss"],
  theme: {
    themes: {
      light: {
        primary: "#0069B1",
        primaryAccent: "#FFFFFF",
        secondary: "#022D2D",
        error: "#D65C5C",
        info: "#022D2D",
        success: "#62C076",
        warning: "#F19F41",
      },
    },
  },
});

